require('./useractivity');

global.PageIcon = {
	icon_timer: null,
	icon_defimg: '/res/i/favicon.ico',
	icon_msgimg: '/res/i/favicon_bg.ico',

	init(){
		let me = this;
		UserActivity.onUserActivityChanged.on(function(active){
			if (active){
				me.stopRolling();
			}
		});
	},

	setIcon(ref){
		$('link[rel~=icon]').attr('href', ref);
	},

	rollIcon(){
		let $icon = $('link[rel~=icon]');
		this.setIcon($icon.attr('href') == this.icon_defimg ? this.icon_msgimg : this.icon_defimg);
	},

	startRolling(){
		if (!this.icon_timer){
			this.icon_timer = setInterval(this.rollIcon.bind(this), 800);
		}
	},

	stopRolling(){
		if (this.icon_timer){
			clearInterval(this.icon_timer);
			this.icon_timer = null;
			this.setIcon(this.icon_defimg);
		}
	},
};
